import { Controller } from "stimulus"

export default class extends Controller {

  connect() {
    $(".selectpicker").selectpicker({ width: '100%' });
    $('#loading').fadeOut(200);
  }
}
